import { Tag } from 'antd';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import type { Priority } from '@shared/types';

const STATE_CLASS: Record<string, string> = {
  New: 'badge-new', Open: 'badge-inprogress', 'In Progress': 'badge-inprogress', 'On Hold': 'badge-onhold', 'Awaiting Info': 'badge-onhold',
  Resolved: 'badge-resolved', Closed: 'badge-closed', Cancelled: 'badge-cancelled', Draft: 'badge-gray', 'Awaiting Approval': 'badge-onhold',
  Approved: 'badge-resolved', Scheduled: 'badge-blue', Implementing: 'badge-inprogress', Review: 'badge-blue', Rejected: 'badge-cancelled',
  Active: 'badge-green', Paused: 'badge-onhold', Retired: 'badge-closed', Dispatched: 'badge-blue', 'Work In Progress': 'badge-inprogress',
  'Closed Complete': 'badge-resolved', 'Closed Incomplete': 'badge-cancelled', Assigned: 'badge-new',
};
const STATE_COLOR: Record<string, string> = {
  'badge-new': 'green', 'badge-inprogress': 'gold', 'badge-onhold': 'default', 'badge-resolved': 'success', 'badge-closed': 'default',
  'badge-cancelled': 'error', 'badge-gray': 'default', 'badge-blue': 'blue', 'badge-green': 'green',
};
const PRIORITY_COLOR: Record<Priority, string> = { P1: 'error', P2: 'volcano', P3: 'gold', P4: 'green' };
const TONE_COLOR = { green: 'green', blue: 'blue', gray: 'default', orange: 'orange', red: 'error' } as const;

/** Legacy class names are kept on the tags so existing tests and page CSS still recognise them. */
export function Badge({ tone = 'gray', children }: { tone?: keyof typeof TONE_COLOR; children: ReactNode }) {
  return <Tag color={TONE_COLOR[tone]} className={clsx('badge', `badge-${tone}`)} style={{ marginInlineEnd: 0 }}>{children}</Tag>;
}
export function PriorityBadge({ priority }: { priority: Priority }) {
  return <Tag color={PRIORITY_COLOR[priority] ?? 'default'} className={clsx('badge', `badge-${priority.toLowerCase()}`)} style={{ marginInlineEnd: 0, fontWeight: 600 }}>{priority}</Tag>;
}
export function StateBadge({ state }: { state: string }) {
  const cls = STATE_CLASS[state] ?? 'badge-gray';
  return <Tag color={STATE_COLOR[cls] ?? 'default'} className={clsx('badge', cls)} style={{ marginInlineEnd: 0 }}>{state}</Tag>;
}
